import React from 'react'

import { Button } from 'components/_new/controls'
import type { ButtonProps } from 'components/_new/controls'

import FloatButtonContainer from '../FloatButtonContainer/FloatButtonContainer'
import type { FloatButtonContainerProps } from '../FloatButtonContainer/FloatButtonContainer'


export type FloatButtonProps = (
  Pick<ButtonProps, 'title' | 'to' | 'disabled' | 'loading' | 'rightIcon' | 'onClick' | 'dataTestId'>
  & Pick<FloatButtonContainerProps, 'className' | 'withShadow' | 'withPlaceholder'>
)

const FloatButton: React.FunctionComponent<FloatButtonProps> = (props) => {
  const {
    children, className, title, to, disabled, loading, dataTestId,
    rightIcon = 'rightArrowSmall', withShadow, withPlaceholder, onClick,
  } = props

  return (
    <FloatButtonContainer
      className={className}
      withShadow={withShadow}
      withPlaceholder={withPlaceholder}
    >
      <Button
        title={title}
        to={to}
        size="md"
        color="brand"
        fullWidthOnMobile
        rightIcon={rightIcon}
        disabled={disabled}
        loading={loading}
        dataTestId={dataTestId}
        onClick={onClick}
      >
        {children}
      </Button>
    </FloatButtonContainer>
  )
}


export default FloatButton
